<div class="crm-page">
  <app-header
    [title]="'TITLES.GOODS' | translate"
    [subtitle]="'COMPONENTS.GOODS.SUBTITLE' | translate"
  >
    <div header-actions class="crm-page__header-actions">
      <div class="hidden lg:block">
        <app-navbar-profile-info></app-navbar-profile-info>
      </div>
    </div>
  </app-header>

  <div class="crm-page__toolbar-bar">
    <div class="crm-toolbar">
      <div class="crm-toolbar__row">
        <div class="crm-list-search form-search">
          <div class="input-search">
            <input
              type="text"
              [value]="searchTerm"
              [placeholder]="'COMPONENTS.GOODS.SEARCH_PLACEHOLDER' | translate"
              [attr.aria-label]="'COMPONENTS.GOODS.SEARCH_PLACEHOLDER' | translate"
              (input)="onSearchChange($any($event.target).value)"
            />
            <span class="search-icon" aria-hidden="true">
              <img src="assets/img/search.svg" alt="" />
            </span>
          </div>
        </div>

        <div class="crm-toolbar__actions">
          @if (bcSyncAvailable) {
            <button
              type="button"
              class="crm-page__action-button crm-import-button goods-page__bc-sync-button"
              [disabled]="isSyncing"
              [attr.aria-label]="'COMPONENTS.GOODS.BC_SYNC.BUTTON_ARIA_LABEL' | translate"
              [title]="'COMPONENTS.GOODS.BC_SYNC.BUTTON_ARIA_LABEL' | translate"
              (click)="onSyncWithBusinessCentral()"
            >
              <span class="crm-import-button-icon" aria-hidden="true">
                <svg
                  class="goods-page__bc-sync-icon"
                  [class.goods-page__bc-sync-icon--spinning]="isSyncing"
                  viewBox="0 0 16 16"
                  fill="none"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path
                    d="M12.75 5.5A5.25 5.25 0 0 0 3.9 3.75"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.25 1.75v2.5h2.5"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.25 10.5a5.25 5.25 0 0 0 8.85 1.75"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.75 14.25v-2.5h-2.5"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="crm-import-button-label hidden md:inline">
                @if (isSyncing) {
                  {{ 'COMPONENTS.GOODS.BC_SYNC.IN_PROGRESS' | translate }}
                } @else {
                  {{ 'COMPONENTS.GOODS.BC_SYNC.BUTTON' | translate }}
                }
              </span>
            </button>
          }
          <div
            class="crm-toolbar__view-mode-switch hidden md:inline-flex"
            role="group"
            [attr.aria-label]="'COMPONENTS.GOODS.VIEW_MODES.SWITCH_ARIA_LABEL' | translate"
          >
            <button
              type="button"
              class="crm-toolbar__view-mode-button"
              [attr.aria-pressed]="viewMode === 'table'"
              [title]="'COMPONENTS.GOODS.VIEW_MODES.TABLE' | translate"
              (click)="setViewMode('table')"
            >
              <span class="sr-only">{{ 'COMPONENTS.GOODS.VIEW_MODES.TABLE' | translate }}</span>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h11A1.5 1.5 0 0 1 15 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5v-11ZM2.5 2a.5.5 0 0 0-.5.5V5h12V2.5a.5.5 0 0 0-.5-.5h-11ZM2 6v3h12V6H2Zm0 4v3.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V10H2Z" />
              </svg>
            </button>
            <button
              type="button"
              class="crm-toolbar__view-mode-button"
              [attr.aria-pressed]="viewMode === 'tiles'"
              [title]="'COMPONENTS.GOODS.VIEW_MODES.TILES' | translate"
              (click)="setViewMode('tiles')"
            >
              <span class="sr-only">{{ 'COMPONENTS.GOODS.VIEW_MODES.TILES' | translate }}</span>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h4A1.5 1.5 0 0 1 8 2.5v4A1.5 1.5 0 0 1 6.5 8h-4A1.5 1.5 0 0 1 1 6.5v-4Zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v4A1.5 1.5 0 0 1 13.5 8h-3A1.5 1.5 0 0 1 9 6.5v-4Zm-8 8A1.5 1.5 0 0 1 2.5 9h4A1.5 1.5 0 0 1 8 10.5v3A1.5 1.5 0 0 1 6.5 15h-4A1.5 1.5 0 0 1 1 13.5v-3Zm8 0A1.5 1.5 0 0 1 10.5 9h3A1.5 1.5 0 0 1 15 10.5v3A1.5 1.5 0 0 1 13.5 15h-3A1.5 1.5 0 0 1 9 13.5v-3Z" />
              </svg>
            </button>
          </div>
          @if (viewMode === 'table') {
            <div class="crm-toolbar__column-settings hidden md:inline-block">
              <button
                type="button"
                class="crm-toolbar__column-settings-button"
                aria-haspopup="menu"
                [attr.aria-expanded]="isColumnMenuOpen"
                aria-controls="goods-columns-menu"
                [attr.aria-label]="'COMPONENTS.GOODS.COLUMNS.BUTTON_LABEL' | translate"
                [title]="'COMPONENTS.GOODS.COLUMNS.BUTTON_LABEL' | translate"
                (click)="toggleColumnMenu()"
              >
                <span class="sr-only">{{ 'COMPONENTS.GOODS.COLUMNS.BUTTON_LABEL' | translate }}</span>
                <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                  <path d="M2 2h12v2H2V2Zm0 5h12v2H2V7Zm0 5h12v2H2v-2Z" />
                </svg>
              </button>

              @if (isColumnMenuOpen) {
                <button
                  type="button"
                  class="crm-toolbar__column-menu-backdrop"
                  tabindex="-1"
                  [attr.aria-label]="'COMPONENTS.GOODS.COLUMNS.BUTTON_LABEL' | translate"
                  (click)="closeColumnMenu()"
                ></button>
                <div
                  id="goods-columns-menu"
                  role="menu"
                  tabindex="-1"
                  class="crm-toolbar__column-menu"
                  (keydown.escape)="closeColumnMenu()"
                >
                  <p class="crm-toolbar__column-menu-title">
                    {{ 'COMPONENTS.GOODS.COLUMNS.DROPDOWN_TITLE' | translate }}
                  </p>
                  @for (column of columns; track column.key) {
                    <label
                      class="crm-toolbar__column-menu-item"
                      role="menuitemcheckbox"
                      [attr.aria-checked]="visibleColumns[column.key]"
                      [attr.aria-disabled]="column.locked"
                      [class.crm-toolbar__column-menu-item--locked]="column.locked"
                    >
                      <input
                        type="checkbox"
                        class="crm-toolbar__column-menu-checkbox"
                        [checked]="visibleColumns[column.key]"
                        [disabled]="column.locked"
                        [attr.aria-label]="'COMPONENTS.GOODS.COLUMNS.TOGGLE_ARIA_LABEL' | translate"
                        (change)="toggleColumn(column.key)"
                      />
                      <span>{{ column.labelKey | translate }}</span>
                    </label>
                  }
                </div>
              }
            </div>
          }

          @if (canCreateGoods$ | async) {
            <button
              type="button"
              class="crm-page__action-button crm-import-button"
              [attr.aria-label]="'BUTTONS.IMPORT' | translate"
              [title]="'BUTTONS.IMPORT' | translate"
              (click)="openImport()"
            >
              <span class="crm-import-button-icon" aria-hidden="true">
                <svg focusable="false" viewBox="0 0 16 16">
                  <path
                    d="M8 1.5a.5.5 0 0 1 .5.5v6.293l2.146-2.147a.5.5 0 1 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 8.293V2a.5.5 0 0 1 .5-.5Zm-5 10A1.5 1.5 0 0 0 4.5 13h7A1.5 1.5 0 0 0 13 11.5v-.5a.5.5 0 0 1 1 0v.5A2.5 2.5 0 0 1 11.5 14h-7A2.5 2.5 0 0 1 2 11.5v-.5a.5.5 0 0 1 1 0v.5Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span class="crm-import-button-label hidden md:inline">
                {{ 'BUTTONS.IMPORT' | translate }}
              </span>
            </button>
            <button
              type="button"
              class="crm-page__action-button crm-page__action-button--brand goods-page__add-button"
              [attr.aria-label]="'BUTTONS.ADD_GOODS' | translate"
              [title]="'BUTTONS.ADD_GOODS' | translate"
              (click)="openCreateGoodsModal()"
            >
              <svg
                class="goods-page__add-button-icon"
                viewBox="0 0 16 16"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M8 2a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 8 2Z" />
              </svg>
              <span class="hidden md:inline">{{ 'BUTTONS.ADD_GOODS' | translate }}</span>
            </button>
          }
        </div>
      </div>

      <div class="crm-toolbar__filters" role="group" [attr.aria-label]="'COMPONENTS.GOODS.FILTERS.CATEGORY_LABEL' | translate">
        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.GOODS.FILTERS.CATEGORY_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.categoryId"
            (change)="onCategoryFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.GOODS.FILTERS.CATEGORY_ALL' | translate }}</option>
            @for (option of categoryOptions; track option.id) {
              <option [value]="option.id">{{ option.title }}</option>
            }
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.GOODS.FILTERS.TYPE_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.type"
            (change)="onTypeFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.GOODS.FILTERS.TYPE_ALL' | translate }}</option>
            @for (option of typeOptions; track option) {
              <option [value]="option">{{ ('COMPONENTS.GOODS.ITEM_TYPES.' + option.toUpperCase()) | translate }}</option>
            }
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.GOODS.FILTERS.STATUS_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.status"
            (change)="onStatusFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.GOODS.FILTERS.STATUS_DEFAULT' | translate }}</option>
            <option value="active">{{ 'COMPONENTS.GOODS.FILTERS.STATUS_ACTIVE_ONLY' | translate }}</option>
            <option value="blocked">{{ 'COMPONENTS.GOODS.FILTERS.STATUS_BLOCKED_ONLY' | translate }}</option>
            <option value="archived">{{ 'COMPONENTS.GOODS.FILTERS.STATUS_ARCHIVED_ONLY' | translate }}</option>
            <option value="all">{{ 'COMPONENTS.GOODS.FILTERS.STATUS_ALL' | translate }}</option>
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.GOODS.FILTERS.STOCK_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.stock"
            (change)="onStockFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.GOODS.FILTERS.STOCK_ANY' | translate }}</option>
            <option value="in">{{ 'COMPONENTS.GOODS.FILTERS.STOCK_IN' | translate }}</option>
            <option value="out">{{ 'COMPONENTS.GOODS.FILTERS.STOCK_OUT' | translate }}</option>
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.GOODS.FILTERS.SOURCE_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.source"
            (change)="onSourceFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.GOODS.FILTERS.SOURCE_ANY' | translate }}</option>
            <option value="bc">{{ 'COMPONENTS.GOODS.FILTERS.SOURCE_BUSINESS_CENTRAL' | translate }}</option>
            <option value="local">{{ 'COMPONENTS.GOODS.FILTERS.SOURCE_LOCAL' | translate }}</option>
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.GOODS.FILTERS.IS_COMPOSITE.LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.isComposite"
            (change)="onIsCompositeFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.GOODS.FILTERS.IS_COMPOSITE.ALL' | translate }}</option>
            <option value="composite">{{ 'COMPONENTS.GOODS.FILTERS.IS_COMPOSITE.COMPOSITE' | translate }}</option>
            <option value="simple">{{ 'COMPONENTS.GOODS.FILTERS.IS_COMPOSITE.SIMPLE' | translate }}</option>
          </select>
        </label>

        @if (activeFilterCount > 0) {
          <button
            type="button"
            class="crm-toolbar__filter-reset"
            (click)="resetFilters()"
          >
            <span aria-hidden="true">×</span>
            {{ 'COMPONENTS.GOODS.FILTERS.RESET' | translate }}
            <span class="crm-toolbar__filter-count">{{ activeFilterCount }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="crm-page__content px-4 md:px-8 py-6 md:py-8">
    @if (isLoading) {
      <div class="crm-page__overlay">
        <div class="goods-page__loading-spinner" aria-hidden="true"></div>
        <span class="sr-only">{{ "MESSAGES.LOADING" | translate }}</span>
      </div>
    }

    @if (goodsView$ | async; as goods) {
      @if (goods.items.length === 0) {
        <app-card-shell class="crm-page__empty-card" padding="none">
          <div class="crm-page__empty-state">
            <app-empty-content
              [showImage]="true"
              [message]="
                'MESSAGES.EMPTY_LIST'
                  | translate: { param: emptyGoodsListParam[currentLang] }
              "
              [tooltip]="'TOOLTIPS.EMPTY_GOODS_LIST' | translate"
              [textPositionClass]="'text-center'"
            />
          </div>
        </app-card-shell>
      } @else {
        <ng-template #tilesGridTpl>
          <div class="crm-tile-grid">
            @for (item of goods.items; track item.id) {
              <article
                class="crm-tile"
                [class.crm-tile--archived]="item.isArchived"
                tabindex="0"
                role="button"
                [attr.aria-label]="item.displayName || item.number || ''"
                (click)="openProduct(item.id)"
                (keydown.enter)="openProduct(item.id)"
              >
                <div class="crm-tile__visual">
                  @if (item.imageUrl !== notFound) {
                    <img
                      class="crm-tile__visual-image"
                      [src]="item.imageUrl"
                      [alt]="item.displayName || item.number || ''"
                    />
                  } @else {
                    <span class="crm-tile__visual-fallback" aria-hidden="true">
                      {{ item.photoLabel }}
                    </span>
                  }

                  @if (item.isArchived) {
                    <span class="crm-tile__archived-overlay">
                      {{ 'INVENTORY_ITEM_STATUSES.ARCHIVED' | translate }}
                    </span>
                  } @else {
                    <span class="crm-tile__status-pill" [ngClass]="item.statusClass">
                      <span class="crm-tile__status-dot" aria-hidden="true"></span>
                      {{ item.statusLabelKey | translate }}
                    </span>
                  }

                  @if (!item.isArchived && item.stock === 0) {
                    <span class="crm-tile__stock-pill crm-tile__stock-pill--empty">
                      ! {{ 'COMPONENTS.GOODS.TILES.NO_STOCK' | translate }}
                    </span>
                  }

                  @if (item.isBusinessCentral) {
                    <span class="crm-tile__source-badge">BC</span>
                  }

                  @if (item.isComposite) {
                    <span
                      class="goods-page__composite-badge goods-page__composite-badge--tile"
                      [title]="'COMPONENTS.GOODS.BADGES.COMPOSITE' | translate"
                    >
                      <svg
                        class="goods-page__composite-badge-icon"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M12 2 2 7l10 5 10-5-10-5Zm0 11.5L3.2 9 2 9.6l10 5 10-5L20.8 9 12 13.5Zm0 4L3.2 13 2 13.6l10 5 10-5-1.2-.6L12 17.5Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>{{ 'COMPONENTS.GOODS.BADGES.COMPOSITE' | translate }}</span>
                    </span>
                  }
                </div>

                <div class="crm-tile__body">
                  <h3 class="crm-tile__title">
                    {{
                      item.displayName
                        || item.number
                        || ('COMMON.EMPTY_VALUE' | translate)
                    }}
                  </h3>
                  <p class="crm-tile__sku">
                    {{ item.number || ('COMMON.EMPTY_VALUE' | translate) }}
                  </p>

                  <div class="crm-tile__meta-row">
                    <span class="crm-tile__category">
                      {{ item.categoryTitle || ('COMPONENTS.GOODS.CATEGORY_PLACEHOLDER' | translate) }}
                    </span>
                    @if (item.itemTypeLabelKey) {
                      <span class="goods-page__type-badge">
                        {{ item.itemTypeLabelKey | translate }}
                      </span>
                    }
                  </div>

                  <div class="crm-tile__price-row">
                    <div class="crm-tile__price-block">
                      <p class="crm-tile__price-label">
                        {{ 'COMPONENTS.GOODS.FIELDS.UNIT_PRICE' | translate }}
                      </p>
                      <p class="crm-tile__price-value">
                        {{ item.unitPrice | number: '1.2-2' }}
                        @if (item.hasCurrencyCode) {
                          <span class="goods-page__currency">{{ item.currencyCode | currencySymbol }}</span>
                        }
                      </p>
                    </div>
                    <div class="crm-tile__stock-block">
                      <p class="crm-tile__price-label">
                        {{ 'COMPONENTS.GOODS.FIELDS.STOCK' | translate }}
                      </p>
                      <p
                        class="crm-tile__stock-value"
                        [class.crm-tile__stock-value--empty]="item.stock === 0"
                      >
                        {{ item.stock | number: '1.0-2' }}
                        @if (item.unit) {
                          <span class="crm-tile__stock-unit">{{ item.unit }}</span>
                        }
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="crm-tile__open-button"
                    (click)="$event.stopPropagation(); openProduct(item.id)"
                  >
                    {{ 'BUTTONS.OPEN' | translate }}
                  </button>
                </div>
              </article>
            }
          </div>
        </ng-template>

        @if (viewMode === 'table') {
        <section class="crm-page__table-section">
        <app-card-shell class="crm-page__list-card" padding="none">
          <div class="crm-table__desktop">
            <div class="crm-table__scroller">
              <table class="crm-table__table">
                <thead>
                  <tr class="crm-table__header-row">
                    @if (visibleColumns.image) {
                      <th class="crm-table__header-cell goods-page__image-header-cell goods-page__column--image">
                        <span class="goods-page__image-header-label">
                          {{ "COMPONENTS.GOODS.FIELDS.IMAGE" | translate }}
                        </span>
                      </th>
                    }
                    @if (visibleColumns.displayName) {
                      <th
                        class="crm-table__header-cell goods-page__column--name"
                        appSortableHeader="displayName"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.DISPLAY_NAME" | translate }}
                      </th>
                    }
                    @if (visibleColumns.sku) {
                      <th
                        class="crm-table__header-cell goods-page__column--sku"
                        appSortableHeader="sku"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.SKU" | translate }}
                      </th>
                    }
                    @if (visibleColumns.category) {
                      <th
                        class="crm-table__header-cell goods-page__column--category"
                        appSortableHeader="category"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.CATEGORY" | translate }}
                      </th>
                    }
                    @if (visibleColumns.type) {
                      <th
                        class="crm-table__header-cell goods-page__column--type"
                        appSortableHeader="type"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.TYPE" | translate }}
                      </th>
                    }
                    @if (visibleColumns.gtin) {
                      <th
                        class="crm-table__header-cell goods-page__column--gtin goods-page__column--laptop-hide"
                        appSortableHeader="gtin"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.GTIN" | translate }}
                      </th>
                    }
                    @if (visibleColumns.stock) {
                      <th
                        class="crm-table__header-cell crm-table__header-cell--numeric goods-page__column--stock"
                        appSortableHeader="stock"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.STOCK" | translate }}
                      </th>
                    }
                    @if (visibleColumns.unit) {
                      <th
                        class="crm-table__header-cell goods-page__column--unit"
                        appSortableHeader="unit"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.UNIT" | translate }}
                      </th>
                    }
                    @if (visibleColumns.unitPrice) {
                      <th
                        class="crm-table__header-cell crm-table__header-cell--numeric goods-page__column--price"
                        appSortableHeader="price"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.UNIT_PRICE" | translate }}
                      </th>
                    }
                    @if (visibleColumns.unitCost) {
                      <th
                        class="crm-table__header-cell crm-table__header-cell--numeric goods-page__column--cost goods-page__column--compact-hide"
                        appSortableHeader="cost"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.UNIT_COST" | translate }}
                      </th>
                    }
                    @if (visibleColumns.status) {
                      <th
                        class="crm-table__header-cell goods-page__column--status"
                        appSortableHeader="status"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.STATUS" | translate }}
                      </th>
                    }
                    @if (visibleColumns.updatedAt) {
                      <th
                        class="crm-table__header-cell goods-page__column--updated-at goods-page__column--laptop-hide"
                        appSortableHeader="updatedAt"
                        [appSortableHeaderActiveColumn]="activeSortColumn"
                        [appSortableHeaderActiveOrder]="activeSortOrder"
                        (appSortableHeaderChange)="onSortChange($event)"
                      >
                        {{ "COMPONENTS.GOODS.FIELDS.UPDATED_AT" | translate }}
                      </th>
                    }
                  </tr>
                </thead>

                <tbody>
                  @for (item of goods.items; track item.id) {
                    <tr
                      class="crm-table__row"
                      [class.goods-page__row--archived]="item.isArchived"
                    >
                      @if (visibleColumns.image) {
                        <td class="crm-table__cell goods-page__image-cell goods-page__column--image">
                          <div class="goods-page__photo">
                            @if (item.imageUrl !== notFound) {
                              <img
                                class="goods-page__photo-image"
                                [src]="item.imageUrl"
                                [alt]="item.displayName || item.number || ''"
                              />
                            } @else {
                              <span>{{ item.photoLabel }}</span>
                            }
                          </div>
                        </td>
                      }
                      @if (visibleColumns.displayName) {
                        <td class="crm-table__cell crm-table__cell--title goods-page__column--name">
                          <div class="goods-page__title-stack">
                            <div class="goods-page__title-row">
                              <a
                                [routerLink]="item.id"
                                [title]="item.displayName || item.number || ''"
                              >
                                {{
                                  item.displayName
                                    || item.number
                                    || ("COMMON.EMPTY_VALUE" | translate)
                                }}
                              </a>
                              @if (item.isComposite) {
                                <span
                                  class="goods-page__composite-badge"
                                  [attr.aria-label]="'COMPONENTS.GOODS.FIELDS.IS_COMPOSITE' | translate"
                                  [title]="'COMPONENTS.GOODS.FIELDS.IS_COMPOSITE' | translate"
                                >
                                  <svg
                                    class="goods-page__composite-badge-icon"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                    focusable="false"
                                  >
                                    <path
                                      d="M12 2 2 7l10 5 10-5-10-5Zm0 11.5L3.2 9 2 9.6l10 5 10-5L20.8 9 12 13.5Zm0 4L3.2 13 2 13.6l10 5 10-5-1.2-.6L12 17.5Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                  <span>{{ 'COMPONENTS.GOODS.BADGES.COMPOSITE' | translate }}</span>
                                </span>
                              }
                            </div>
                            @if (item.displayName2) {
                              <p
                                class="goods-page__secondary-text"
                                [title]="item.displayName2"
                              >
                                {{ item.displayName2 }}
                              </p>
                            }
                            <p class="goods-page__source-text">
                              {{ item.sourceLabelKey | translate }}
                            </p>
                          </div>
                        </td>
                      }
                      @if (visibleColumns.sku) {
                        <td class="crm-table__cell goods-page__column--sku">
                          <a [routerLink]="item.id" [title]="item.number || ''">
                            {{ item.number || ("COMMON.EMPTY_VALUE" | translate) }}
                          </a>
                        </td>
                      }
                      @if (visibleColumns.category) {
                        <td class="crm-table__cell goods-page__column--category" [title]="item.categoryTitle || ''">
                          {{
                            item.categoryTitle
                              || ("COMPONENTS.GOODS.CATEGORY_PLACEHOLDER" | translate)
                          }}
                        </td>
                      }
                      @if (visibleColumns.type) {
                        <td class="crm-table__cell goods-page__column--type">
                          @if (item.itemTypeLabelKey) {
                            <span class="goods-page__type-badge">
                              {{ item.itemTypeLabelKey | translate }}
                            </span>
                          } @else {
                            {{ "COMMON.EMPTY_VALUE" | translate }}
                          }
                        </td>
                      }
                      @if (visibleColumns.gtin) {
                        <td class="crm-table__cell goods-page__column--gtin goods-page__column--laptop-hide" [title]="item.gtin || ''">
                          {{ item.gtin || ("COMMON.EMPTY_VALUE" | translate) }}
                        </td>
                      }
                      @if (visibleColumns.stock) {
                        <td class="crm-table__cell crm-table__cell--numeric goods-page__column--stock">
                          {{ item.stock | number: "1.0-2" }}
                        </td>
                      }
                      @if (visibleColumns.unit) {
                        <td class="crm-table__cell goods-page__column--unit">
                          {{ item.unit || ("COMMON.EMPTY_VALUE" | translate) }}
                        </td>
                      }
                      @if (visibleColumns.unitPrice) {
                        <td class="crm-table__cell crm-table__cell--numeric goods-page__column--price">
                          {{ item.unitPrice | number: "1.2-2" }}
                          @if (item.hasCurrencyCode) {
                            <span class="goods-page__currency">{{ item.currencyCode | currencySymbol }}</span>
                          }
                        </td>
                      }
                      @if (visibleColumns.unitCost) {
                        <td class="crm-table__cell crm-table__cell--numeric goods-page__column--cost goods-page__column--compact-hide">
                          {{ item.unitCost | number: "1.2-2" }}
                          @if (item.hasCurrencyCode) {
                            <span class="goods-page__currency">{{ item.currencyCode | currencySymbol }}</span>
                          }
                        </td>
                      }
                      @if (visibleColumns.status) {
                        <td class="crm-table__cell goods-page__column--status">
                          <span class="goods-page__status-badge" [ngClass]="item.statusClass">
                            {{ item.statusLabelKey | translate }}
                          </span>
                        </td>
                      }
                      @if (visibleColumns.updatedAt) {
                        <td
                          class="crm-table__cell goods-page__column--laptop-hide"
                          [title]="(item.lastModifiedDateTime | date: uaDateFormat) || ''"
                        >
                          {{ item.lastModifiedDateTime | date: uaDateFormat }}
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div class="crm-page__footer goods-page__footer goods-page__footer--desktop">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="goods.totalCount"
              [page]="goods.page"
              [pageSize]="goods.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </app-card-shell>
        </section>
        }

        <section
          class="crm-page__tile-section"
          [class.crm-page__tile-section--desktop-hidden]="viewMode === 'table'"
        >
          <ng-container *ngTemplateOutlet="tilesGridTpl"></ng-container>

          <div class="crm-page__footer goods-page__footer goods-page__footer--tiles">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="goods.totalCount"
              [page]="goods.page"
              [pageSize]="goods.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </section>
      }
    }

    <app-reusable-modal
      [isOpen]="isCreateGoodsModalOpen"
      [panelClass]="'max-w-4xl'"
      [contentScoped]="true"
      [title]="'TITLES.ADD_GOODS' | translate"
      [subtitle]="'COMPONENTS.GOODS.CREATE_MODAL_SUBTITLE' | translate"
      (closed)="closeCreateGoodsModal()"
    >
      <app-create-goods
        [companyId]="companyId"
        (cancelled)="closeCreateGoodsModal()"
        (created)="onCreateGoods()"
      />
    </app-reusable-modal>
  </div>
</div>

<!-- Toast container is mounted here so the BC sync completion toast (pushed by
     BusinessCentralSyncListenerService when the SignalR event arrives) actually
     renders on the page where the user triggered the sync. Other pages mount their
     own; the toast service is a root singleton so whichever container is currently
     mounted displays the toast. -->
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<ng-template #bcSyncRequestFailedTpl>
  {{ 'COMPONENTS.GOODS.BC_SYNC.TOAST_REQUEST_FAILED' | translate }}
</ng-template>
